import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

console.log('[Pod] ========================================');
console.log('[Pod] Copilot Assistant Pod Starting...');
console.log('[Pod] Version: 1.1.0');
console.log('[Pod] Environment:', import.meta.env.MODE);
console.log('[Pod] API URL:', import.meta.env.VITE_API_URL);
console.log('[Pod] Azure Client ID:', import.meta.env.VITE_AZURE_CLIENT_ID);
console.log('[Pod] ConnectWise Origin:', import.meta.env.VITE_CONNECTWISE_ORIGIN);
console.log('[Pod] ========================================');

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
